<div class="full-bg-cover"></div>
<div class="text-center">
  @if (audio) {
    <div>
      <h1>Interviewing Exercise – Part I</h1>
      <hr/>
      <p>You are about to be asked to rate real applicants’ responses to interview questions.  Remember that nobody except you will know what ratings you allocate so, to get the most out of this exercise, we ask you to rate them authentically and instinctively, without overthinking things. </p>
      <p>Consequently, you will only be able to score each clip once.  You will not be able to change your answer once scored.  Whilst you will be able to pause clips if required, you will not be able to rewind, or replay, any clips.</p>
      <hr />
      <button data-testid="rating-intro-start" (click)="onStart()" class="btn btn-outline-primary btn-outline hover active">Start</button>
    </div>
  }
  @if (video) {
    <div>
      <h1>Interviewing Exercise – Part II</h1>
      <hr/>
      <p>You will again be asked to rate responses to a series of interview questions.  As before, please allocate ratings instinctively and don’t overthink your responses.</p>
      <p>You will again only be able to score each clip once.  You will not be able to change your answer once scored.  Whilst you will be able to pause clips if required, you will not be able to rewind, or replay, any clips.</p>
      <hr />
      <button data-testid="rating-intro-start" (click)="onStart()" class="btn btn-outline-primary btn-outline hover active">Start</button>
    </div>
  }
</div>
<app-progress-bar [progressValue]=courseProgress></app-progress-bar>
